import { render, staticRenderFns } from "./reservationEdit.vue?vue&type=template&id=580d1b75&"
import script from "./reservationEdit.vue?vue&type=script&lang=js&"
export * from "./reservationEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports